import Api from '../Api';

import { url } from './config';
import { Permission } from './types';

const api = new Api<Permission>(url);

export default api;
